import { api, ApiError } from "../api.ts";
import { h, setMsg } from "../dom.ts";
import { brandLockup, BRAND_NAME } from "../ui/brand.ts";
import { t } from "../i18n/index.ts";
import { loginScreen } from "./login.ts";

/** The "apply to join" card, swapped in when "Become a member" is clicked. */
export function joinCard(): HTMLElement {
  const el = h(`
    <main class="card auth-card">
      <h1 class="brand" aria-label="${BRAND_NAME}">${brandLockup}</h1>
      <h2 class="join-title">${t("join.title")}</h2>
      <p class="tagline">${t("join.intro")}</p>
      <form novalidate>
        <label class="field"><span>${t("join.name")}</span>
          <input name="name" autocomplete="name" autofocus required maxlength="100" /></label>
        <label class="field"><span>${t("join.email")}</span>
          <input name="email" type="email" autocomplete="email" required maxlength="200" />
          <small class="fine">${t("join.emailHelp")}</small></label>
        <label class="field"><span>${t("join.experience")}</span>
          <input name="experience" maxlength="120" />
          <small class="fine">${t("join.experienceOpt")}</small></label>
        <label class="field"><span>${t("join.message")}</span>
          <textarea name="message" rows="3" maxlength="1000" class="pgn-input"></textarea>
          <small class="fine">${t("join.messageOpt")}</small></label>
        <button class="btn primary" type="submit">${t("join.submit")}</button>
        <p class="msg" role="status" aria-live="polite"></p>
      </form>
      <p class="fine"><a href="#" class="back-login">${t("join.back")}</a></p>
    </main>
  `);

  const form = el.querySelector("form")!;
  const msg = el.querySelector(".msg") as HTMLElement;
  const button = el.querySelector("button.primary") as HTMLButtonElement;

  el.querySelector(".back-login")!.addEventListener("click", (e) => {
    e.preventDefault();
    el.replaceWith(loginScreen());
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const d = new FormData(form);
    const name = String(d.get("name") ?? "").trim();
    const email = String(d.get("email") ?? "").trim();
    const experience = String(d.get("experience") ?? "").trim();
    const message = String(d.get("message") ?? "").trim();
    if (!name) { setMsg(msg, t("join.needName"), "bad"); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setMsg(msg, t("join.needEmail"), "bad"); return; }
    button.disabled = true;
    setMsg(msg, t("join.sending"));
    try {
      await api.apply({ name, email, experience, message });
      // Success: replace the form with a confirmation.
      form.replaceWith(h(`<p class="ok-line">${t("join.success")}</p>`));
      setMsg(msg, "");
    } catch (err) {
      setMsg(msg, err instanceof ApiError ? err.message : t("join.failed"), "bad");
      button.disabled = false;
    }
  });

  return el;
}
